import { computed, effect, Injectable, signal } from '@angular/core';
import { Lang, LANGS, MESSAGES } from './messages';
import { storage } from './storage';

const STORAGE_KEY = 'cortito-lang';

/**
 * The chosen language is applied twice: by the inline script in `index.html`
 * before the first paint, and here once Angular boots. Both must agree —
 * `STORAGE_KEY` and the way the browser language is read are repeated there
 * on purpose, since that script runs long before this bundle exists.
 */
@Injectable({ providedIn: 'root' })
export class I18nService {
  readonly lang = signal<Lang>(readStoredLang());
  readonly t = computed(() => MESSAGES[this.lang()]);

  constructor() {
    effect(() => {
      const lang = this.lang();
      document.documentElement.lang = lang;
      document
        .querySelector('meta[name="description"]')
        ?.setAttribute('content', this.t().description);
      storage()?.setItem(STORAGE_KEY, lang);
    });
  }

  next(): void {
    this.lang.update((lang) => LANGS[(LANGS.indexOf(lang) + 1) % LANGS.length]);
  }
}

/** Anything that is not Spanish gets English, the wider of the two. */
export function browserLang(): Lang {
  return (navigator.language ?? '').toLowerCase().startsWith('es') ? 'es' : 'en';
}

function readStoredLang(): Lang {
  const stored = storage()?.getItem(STORAGE_KEY);
  return LANGS.includes(stored as Lang) ? (stored as Lang) : browserLang();
}
